import { useCallback, useEffect } from 'react';
import { Pagination } from 'rsuite';
import { PaginationWrapper } from './card-viewer-styles';

// number of page options to display before ... appears
const NUM_PAGINATION_OPTIONS = 5;
// X,Y Coordinates to scroll to top of page
const PAGE_TOP = [0, 0];

/**
 * Paginator at the bottom of CardViewer
 *
 * @export CardViewerPaginator
 * @param {*} props
 * @returns JSX.Element
 */
export function CardViewerPaginator(props) {
  const { numPages, paginationContainer, setCurrentPage, currentPage } = props;

  const handlePageSelect = useCallback(
    (eventKey) => {
      setCurrentPage(eventKey);
      requestAnimationFrame(() =>
        // Optional chaining for "scrollTo" to fix a potential client crash when the method is irretrievable.
        paginationContainer.current?.scrollTo(...PAGE_TOP)
      );
    },
    [paginationContainer, setCurrentPage]
  );

  useEffect(() => {
    if (currentPage > numPages) handlePageSelect(1);
  }, [currentPage, handlePageSelect, numPages]);

  return (
    <PaginationWrapper>
      <Pagination
        prev
        next
        size="md"
        ellipsis
        boundaryLinks
        maxButtons={NUM_PAGINATION_OPTIONS}
        pages={numPages}
        activePage={currentPage}
        onSelect={(eventKey) => handlePageSelect(eventKey)}
      />
    </PaginationWrapper>
  );
}
